import * as firebase from 'firebase';

import { 
  FIREBASE_API_KEY, 
  FIREBASE_PROJECT_ID, 
  FIREBASE_MESSAGING_SENDER_ID 
} from './config.json';


//Initialize Firebase
var config = {
    apiKey: FIREBASE_API_KEY,
    authDomain: `${FIREBASE_PROJECT_ID}.firebaseapp.com`,
    databaseURL: `https://${FIREBASE_PROJECT_ID}.firebaseio.com`,
    projectId: FIREBASE_PROJECT_ID,
    storageBucket: `${FIREBASE_PROJECT_ID}.appspot.com`,
    messagingSenderId: FIREBASE_MESSAGING_SENDER_ID
};

firebase.initializeApp(config);

export default firebase;